'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CopyButtonIntl = exports.CodeEditor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _copyToClipboard = require('copy-to-clipboard');

var _copyToClipboard2 = _interopRequireDefault(_copyToClipboard);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _reactBootstrap = require('react-bootstrap');

require('codemirror/mode/shell/shell');

require('codemirror/mode/jsx/jsx');

require('codemirror/addon/mode/simple');

require('codemirror/addon/scroll/simplescrollbars');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// The JSX mode imports both javascript and XML modes as well, so there is no
// need to explicitly import them.


var codemirror = require('codemirror');

// predefine gutters objects for quick equality checks
var gutters = {
	lint: ['CodeMirror-lint-markers'],
	none: []
};

var CopyButton = function (_React$Component) {
	_inherits(CopyButton, _React$Component);

	function CopyButton(props) {
		_classCallCheck(this, CopyButton);

		var _this = _possibleConstructorReturn(this, (CopyButton.__proto__ || Object.getPrototypeOf(CopyButton)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		_this.onClick = _this.onClick.bind(_this);
		_this.state = {
			copied: false
		};
		return _this;
	}

	_createClass(CopyButton, [{
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			clearTimeout(this.copiedTimeout);
		}
	}, {
		key: 'onClick',
		value: function onClick() {
			var _this2 = this;

			this.setState({
				copied: true
			});
			this.props.onClick();
			// Reset state after 1 second
			this.copiedTimeout = setTimeout(function () {
				_this2.setState({
					copied: false
				});
			}, 1000);
		}
	}, {
		key: 'render',
		value: function render() {
			var copied = this.state.copied;
			var right = this.props.right;

			return _react2.default.createElement(
				'div',
				{
					style: { right: right },
					className: (0, _classnames2.default)('copy', { copied: copied })
				},
				_react2.default.createElement(
					_reactBootstrap.Button,
					{
						bsStyle: 'primary',
						className: 'btn-copy',
						onClick: this.onClick
					},
					this.intl.formatMsg('Copy')
				),
				_react2.default.createElement(
					_reactBootstrap.Button,
					{ bsStyle: 'primary', className: 'btn-copied' },
					this.intl.formatMsg('Copied')
				)
			);
		}
	}]);

	return CopyButton;
}(_react2.default.Component);

CopyButton.propTypes = {
	onClick: _propTypes2.default.func.isRequired,
	right: _propTypes2.default.number
};

CopyButton.defaultProps = {
	right: 0
};

/**
 * CodeMirror internal class
 */

var CodeMirror = function (_React$Component2) {
	_inherits(CodeMirror, _React$Component2);

	function CodeMirror(props) {
		_classCallCheck(this, CodeMirror);

		var _this3 = _possibleConstructorReturn(this, (CodeMirror.__proto__ || Object.getPrototypeOf(CodeMirror)).call(this, props));

		_this3.state = {};
		_this3.onViewportChange = _this3.onViewportChange.bind(_this3);
		// Tracks which dependencies have been loaded yet.
		// (see deferDependencies)
		_this3.definedDependencies = {
			headers: false,
			mustache: false
		};
		_this3.deferDependencies(props.options);
		return _this3;
	}

	_createClass(CodeMirror, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _props = this.props,
			    options = _props.options,
			    onViewportChange = _props.onViewportChange,
			    onChange = _props.onChange,
			    onBeforeChange = _props.onBeforeChange;


			this.codeMirror = codemirror.fromTextArea(this.textarea, options);
			this.codeMirror.on('change', onChange);
			if (onBeforeChange) {
				this.codeMirror.on('beforeChange', onBeforeChange);
			}
			// handle viewport change to align copy button correctly
			if (onViewportChange) {
				this.onViewportChange();
				window.addEventListener('resize', this.onViewportChange);
				this.codeMirror.on('viewportChange', this.onViewportChange);
			}
		}
	}, {
		key: 'onViewportChange',
		value: function onViewportChange() {
			var onViewportChange = this.props.onViewportChange;
			// store offset regardless of copy button being shown

			var scrollbar = this.textarea.parentNode.getElementsByClassName('CodeMirror-vscrollbar');
			onViewportChange(this.codeMirror, {
				// width of the vertical scrollbar within the editor
				offsetX: scrollbar[0] ? scrollbar[0].offsetWidth : 0
			});
		}
	}, {
		key: 'deferDependencies',
		value: function deferDependencies(_ref) {
			var lint = _ref.lint,
			    mode = _ref.mode;

			var deps = this.definedDependencies;
			// Defer loading of jshint and jsonlint into the browser
			// until they are needed
			if (lint && mode === 'javascript' && !window.JSHINT) {
				require('codemirror/addon/lint/lint');
				require('codemirror/addon/lint/javascript-lint');
				window.JSHINT = require('jshint/dist/jshint').JSHINT;
			} else if (lint && mode === 'application/json' && !window.jsonlint) {
				require('codemirror/addon/lint/lint');
				require('codemirror/addon/lint/json-lint');
				window.jsonlint = require('../utility/jsonlint');
			} else if (!deps.headers && mode === 'headers') {
				deps.headers = true;
				codemirror.defineSimpleMode('headers', {
					// The start state contains the rules that are intially used
					start: [
					// The regex matches the token, the token property contains the type
					{ regex: /^[\w+\-$]+:/, token: 'string' }, { regex: /.*$/, token: 'variable' }],
					// The meta property contains global information about the mode. It
					// can contain properties like lineComment, which are supported by
					// all modes, and also directives like dontIndentStates, which are
					// specific to simple modes.
					meta: {
						dontIndentStates: [],
						lineComment: '//'
					}
				});
			} else if (!deps.mustache && mode === 'mustache') {
				deps.mustache = true;
				codemirror.defineSimpleMode('mustache', {
					start: [{ regex: /\{\{!/, push: 'comment', token: 'comment' }, { regex: /\{\{(?:\^|\/|#|&|>)/, push: 'invert', token: 'atom' }, { regex: /\{\{/, push: 'tag', token: 'builtin' }],
					comment: [{ regex: /\}\}/, pop: true, token: 'comment' }, { regex: /./, token: 'comment' }],
					tag: [{ regex: /\}\}/, pop: true, token: 'builtin' }, { regex: /./, token: 'builtin' }],
					invert: [{ regex: /\}\}/, pop: true, token: 'atom' }, { regex: /./, token: 'atom' }]
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (this.codeMirror) {
				this.codeMirror.toTextArea();
				this.codeMirror = null;
			}
			if (this.props.onViewportChange) {
				window.removeEventListener('resize', this.onViewportChange);
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(next) {
			this.deferDependencies(next.options);
			for (var key in next.options) {
				// setOption is expensive, don't call it unless the value changed
				if (this.props.options && this.props.options[key] !== next.options[key]) {
					this.codeMirror.setOption(key, next.options[key]);
				}
			}
		}
	}, {
		key: 'getCodeMirror',
		value: function getCodeMirror() {
			return this.codeMirror;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this4 = this;

			var value = this.props.value;

			return _react2.default.createElement('textarea', {
				ref: function ref(c) {
					_this4.textarea = c;
				},
				defaultValue: value,
				autoComplete: 'off'
			});
		}
	}]);

	return CodeMirror;
}(_react2.default.Component);

CodeMirror.propTypes = {
	onChange: _propTypes2.default.func.isRequired,
	onViewportChange: _propTypes2.default.func,
	onBeforeChange: _propTypes2.default.func,
	options: _propTypes2.default.shape({
		lineNumbers: _propTypes2.default.bool
	}),
	value: _propTypes2.default.string
};

/**
 * CodeEditor
 */

var CodeEditor = exports.CodeEditor = function (_React$Component3) {
	_inherits(CodeEditor, _React$Component3);

	function CodeEditor(props) {
		_classCallCheck(this, CodeEditor);

		var _this5 = _possibleConstructorReturn(this, (CodeEditor.__proto__ || Object.getPrototypeOf(CodeEditor)).call(this, props));

		_this5.state = {};
		_axwayReactIntl2.default.init(_this5);
		_this5.code = props.code;
		_this5.onChange = _this5.onChange.bind(_this5);
		_this5.onCopy = _this5.onCopy.bind(_this5);
		_this5.onViewportChange = _this5.onViewportChange.bind(_this5);
		return _this5;
	}

	_createClass(CodeEditor, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this._cm && this.props.tail) {
				var cm = this._cm.getCodeMirror();
				var doc = cm.getDoc();
				cm.setCursor({ line: doc.lastLine() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate() {
			var _this6 = this;

			if (this._cm) {
				this.refreshTimeout = setTimeout(function () {
					_this6._cm && _this6._cm.getCodeMirror().refresh();
				}, 0);
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			clearTimeout(this.refreshTimeout);
		}
	}, {
		key: 'onChange',
		value: function onChange() {
			var value = null;
			if (this._cm) {
				value = this._cm.getCodeMirror().getDoc().getValue();
			}
			if (value !== this.code) {
				var onChange = this.props.onChange;

				this.code = value;
				onChange && onChange(value);
			}
		}
	}, {
		key: 'isScrolledToEnd',
		value: function isScrolledToEnd() {
			var cm = this._cm.getCodeMirror();
			var scroller = cm.getScrollerElement();

			var scrollTop = scroller.scrollTop,
			    scrollHeight = scroller.scrollHeight,
			    clientTop = scroller.clientTop,
			    clientHeight = scroller.clientHeight;


			var isScrollable = scrollTop !== clientTop || scrollHeight !== clientHeight;
			if (!isScrollable) {
				// it is not scrollable so it is at end
				return true;
			}

			// The `scrollHeight` is the full height of the element.  The
			// `scrollTop` is the number of pixels the element's content is
			// scrolled vertically.  The `clientHight` is the viewable
			// portion of the content.  It's difficult to explain, but to
			// check if the scroll is at the bottom, we have to subtract
			// the `scrollHeight`.  A picture might help:
			// .==========.
			// | scroll 0 |
			// |          |
			// |          |
			// |          |.----------
			// |        4 |# 0 client #
			// |          |#          #
			// |          |#          #
			// |          |#          #
			// |        8 |# 4        #
			// `=========='`----------'
			// At certain zoom levels, scrollTop may be a decimal such
			// as 423.6363525390625 depending on the browser scale.
			// We round up scrollTop to the nearest integer, so that the
			// following calculation correctly determines that the scroll
			// is at the end. Otherwise the difference increases by
			// the decimal remainder each time a new line is added.
			var isScrollEnd = scrollHeight - Math.ceil(scrollTop) <= clientHeight;
			return isScrollEnd;
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (!this._cm) {
				return;
			}

			// Update codemirror based on prop changes and try to
			// persist the previous state as much as possible.
			try {
				var cm = this._cm.getCodeMirror();
				var doc = cm.getDoc();
				var value = doc.getValue();
				var valueChanged = value !== nextProps.code;

				// If the value didn't change then there's nothing to do.
				if (!valueChanged) {
					return;
				}

				// The cursor position where the current selection began
				var cursorAnchor = cm.getCursor('anchor');
				// The cursor position where the current selection ended.
				var cursorHead = cm.getCursor('head');
				var isScrollEnd = this.props.tail && this.isScrolledToEnd();
				var originalScrollInfo = void 0;
				if (!isScrollEnd) {
					originalScrollInfo = cm.getScrollInfo();
				}
				// Only set the new value if changed, otherwise can
				// trigger render loop due to onChange callback.
				cm.setValue(nextProps.code);

				// On update, the cursor would snap back to the beginning.
				// We can do better than just updating the cursor position,
				// and restore the previous selection (otherwise it would get
				// annoying when text deselects on update).
				cm.setSelection(cursorAnchor, cursorHead);

				if (isScrollEnd) {
					// && this.props.tail (implicitly)
					// If we're on the last line, then after we update the text
					// ensure that we scroll to the last line again.
					cm.scrollIntoView({ line: doc.lastLine() });
				} else {
					// Persists the exact previous scroll location
					// when the content changes
					// TODO: figure out if this is only needed on text update
					cm.scrollTo(originalScrollInfo.left, originalScrollInfo.top);
				}
			} catch (e) {
				// ignore error
			}
		}
	}, {
		key: 'onCopy',
		value: function onCopy() {
			(0, _copyToClipboard2.default)(this._cm.getCodeMirror().getValue());
		}
	}, {
		key: 'onViewportChange',
		value: function onViewportChange(cm, _ref2) {
			var offsetX = _ref2.offsetX;

			this.setState({
				offsetX: offsetX
			});
		}
	}, {
		key: 'getCodeMirror',
		value: function getCodeMirror() {
			return this._cm.getCodeMirror();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this7 = this;

			var _props2 = this.props,
			    className = _props2.className,
			    code = _props2.code,
			    description = _props2.description,
			    modal = _props2.modal,
			    show = _props2.show,
			    saveAction = _props2.saveAction,
			    closeAction = _props2.closeAction,
			    lineWrapping = _props2.lineWrapping,
			    lineNumbers = _props2.lineNumbers,
			    viewportMargin = _props2.viewportMargin,
			    onBeforeChange = _props2.onBeforeChange,
			    theme = _props2.theme,
			    copyButton = _props2.copyButton,
			    readOnly = _props2.readOnly,
			    nocursor = _props2.nocursor;


			var mode = this.props.mode;
			if (mode === 'json') {
				mode = 'application/json';
			}
			var cursorBlinkRate = 530;
			if (readOnly === true && nocursor) {
				// A negative number hides the cursor. readonly: 'nocursor' does not bind
				// any event listeners, so don't use that method.
				cursorBlinkRate = -1;
			} else if (readOnly) {
				cursorBlinkRate = 0;
			}

			var lint = !readOnly && this.props.lint;

			if (lint && mode === 'javascript') {
				// enable es9 support when linting js
				lint = {
					esversion: 9
				};
			}

			var options = {
				lint: lint,
				gutters: lint ? gutters.lint : gutters.none,
				cursorBlinkRate: cursorBlinkRate,
				autofocus: false,
				readOnly: readOnly,
				lineWrapping: lineWrapping,
				lineNumbers: lineNumbers,
				viewportMargin: viewportMargin,
				theme: theme,
				mode: mode
			};

			var cm = _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)('code-editor', className) },
				_react2.default.createElement(CodeMirror, {
					ref: function ref(c) {
						_this7._cm = c;
					},
					value: code,
					options: options,
					onViewportChange: copyButton ? this.onViewportChange : null,
					onChange: this.onChange,
					onBeforeChange: onBeforeChange
				}),
				copyButton && _react2.default.createElement(CopyButtonIntl, { right: this.state.offsetX, onClick: this.onCopy })
			);
			if (modal) {
				return _react2.default.createElement(
					_reactBootstrap.Modal,
					{ show: show },
					_react2.default.createElement(
						_reactBootstrap.Modal.Header,
						null,
						_react2.default.createElement(
							_reactBootstrap.Modal.Title,
							null,
							description
						)
					),
					_react2.default.createElement(
						_reactBootstrap.Modal.Body,
						null,
						cm
					),
					_react2.default.createElement(
						_reactBootstrap.Modal.Footer,
						null,
						_react2.default.createElement(
							_reactBootstrap.Button,
							{ onClick: closeAction, bsSize: 'large' },
							this.intl.formatMsg('Close')
						),
						!readOnly && _react2.default.createElement(
							_reactBootstrap.Button,
							{ bsStyle: 'primary', bsSize: 'large', onClick: function onClick() {
									saveAction && saveAction(_this7.code);
								} },
							this.intl.formatMsg('Save changes')
						)
					)
				);
			}
			return cm;
		}
	}]);

	return CodeEditor;
}(_react2.default.Component);

CodeEditor.propTypes = {
	className: _propTypes2.default.string,
	code: _propTypes2.default.string,
	// javascript, json, etc.
	mode: _propTypes2.default.string,
	theme: _propTypes2.default.oneOf(['monokai', 'eclipse']),
	lint: _propTypes2.default.bool,
	readOnly: _propTypes2.default.bool,
	// when readOnly, this option will disable the cursor state (default false)
	nocursor: _propTypes2.default.bool,
	description: _propTypes2.default.string,
	onChange: _propTypes2.default.func,
	onBeforeChange: _propTypes2.default.func,
	modal: _propTypes2.default.bool,
	show: _propTypes2.default.bool,
	saveAction: _propTypes2.default.func,
	closeAction: _propTypes2.default.func,
	viewportMargin: _propTypes2.default.number,
	lineNumbers: _propTypes2.default.bool,
	lineWrapping: _propTypes2.default.bool,
	// Show copy button on hover
	copyButton: _propTypes2.default.bool,
	// Scrolls to the end of the `code` and will stay there on update unless
	// the user manually scrolls.
	tail: _propTypes2.default.bool
};

CodeEditor.defaultProps = {
	mode: 'javascript',
	readOnly: false,
	nocursor: false,
	lint: false,
	modal: false,
	show: false,
	theme: 'monokai',
	viewportMargin: Infinity,
	lineNumbers: true,
	lineWrapping: true,
	copyButton: false,
	tail: false
};

var CopyButtonIntl = exports.CopyButtonIntl = (0, _reactIntl.injectIntl)(CopyButton);

var _default = (0, _reactIntl.injectIntl)(CodeEditor);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(gutters, 'gutters', 'src/components/CodeEditor.jsx');

	__REACT_HOT_LOADER__.register(CopyButton, 'CopyButton', 'src/components/CodeEditor.jsx');

	__REACT_HOT_LOADER__.register(CodeMirror, 'CodeMirror', 'src/components/CodeEditor.jsx');

	__REACT_HOT_LOADER__.register(CodeEditor, 'CodeEditor', 'src/components/CodeEditor.jsx');

	__REACT_HOT_LOADER__.register(CopyButtonIntl, 'CopyButtonIntl', 'src/components/CodeEditor.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/CodeEditor.jsx');
}();

;